var _g, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcPlanOnboarding0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 56,
    r: 42,
    fill: "#fff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.309 38.697h-5.025v-.756c0-1.084-.88-1.964-1.957-1.964h-2.4l-1.163-1.89a2.26 2.26 0 0 0-1.935-1.077h-1.65c-.794 0-1.514.4-1.935 1.076L49.08 35.97h-2.4c-1.084 0-1.956.88-1.956 1.963v.75H39.69a3.53 3.53 0 0 0-3.527 3.527v33.236a3.53 3.53 0 0 0 3.527 3.527h26.618a3.53 3.53 0 0 0 3.527-3.527V42.21a3.523 3.523 0 0 0-3.527-3.513m-20.19-.756c0-.306.248-.553.546-.553h2.793a.68.68 0 0 0 .596-.335l1.375-2.218a.87.87 0 0 1 .735-.407h1.65c.299 0 .582.16.735.407l1.375 2.218a.7.7 0 0 0 .596.335h2.785c.306 0 .546.247.546.553v2.174a.545.545 0 0 1-.546.546H46.673a.545.545 0 0 1-.546-.546v-2.174zm22.306 37.52a2.12 2.12 0 0 1-2.116 2.116H39.691a2.12 2.12 0 0 1-2.117-2.116V42.224c0-1.163.946-2.116 2.117-2.116h5.025v.015c0 1.083.88 1.956 1.957 1.956h12.654c1.084 0 1.957-.88 1.957-1.956v-.015h5.025c1.164 0 2.116.945 2.116 2.116z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.433 36.608h1.134a.706.706 0 0 0 0-1.41h-1.134a.7.7 0 0 0-.706.705c0 .392.313.705.706.705",
    fill: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.135 45.736h-4.153c-1.026 0-1.855.83-1.855 1.855v4.153c0 1.025.83 1.854 1.855 1.854h4.153a1.853 1.853 0 0 0 1.854-1.854V47.59c0-1.026-.83-1.855-1.854-1.855m.443 6.015a.445.445 0 0 1-.444.444h-4.152a.445.445 0 0 1-.444-.444v-4.153c0-.247.204-.444.444-.444h4.153c.247 0 .443.204.443.444zm18.706-4.414H51.436a.7.7 0 0 0-.705.705c0 .393.313.706.705.706h13.84a.7.7 0 0 0 .706-.706.696.696 0 0 0-.698-.705m-13.848 4.671h8.037a.7.7 0 0 0 .705-.706.7.7 0 0 0-.705-.705h-8.037a.7.7 0 0 0-.705.705c0 .386.32.706.705.706",
    fill: "#E5A033"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.135 55.64h-4.153a1.86 1.86 0 0 0-1.855 1.855v4.153c0 1.025.83 1.854 1.855 1.854h4.153a1.853 1.853 0 0 0 1.854-1.854v-4.153c0-1.018-.83-1.854-1.854-1.854m.443 6.015a.445.445 0 0 1-.444.444h-4.152a.445.445 0 0 1-.444-.444v-4.153c0-.247.204-.443.444-.443h4.153c.247 0 .443.203.443.443zm18.706-4.406H51.436a.7.7 0 0 0-.705.706c0 .392.313.705.705.705h13.84a.7.7 0 0 0 .706-.706.7.7 0 0 0-.698-.705m-13.848 4.663h8.037a.7.7 0 0 0 .705-.706.7.7 0 0 0-.705-.705h-8.037a.706.706 0 0 0 0 1.41m-5.301 3.643h-4.153a1.853 1.853 0 0 0-1.855 1.854v4.153c0 1.025.83 1.855 1.855 1.855h4.153a1.86 1.86 0 0 0 1.854-1.855v-4.153c0-1.018-.83-1.854-1.854-1.854m.443 6.014a.445.445 0 0 1-.444.444h-4.152a.445.445 0 0 1-.444-.444v-4.153c0-.247.204-.443.444-.443h4.153c.247 0 .443.204.443.444zm18.706-4.413H51.436a.7.7 0 0 0-.705.706c0 .392.313.705.705.705h13.84a.7.7 0 0 0 .706-.705.696.696 0 0 0-.698-.706m-5.804 3.256h-8.044a.7.7 0 0 0-.705.706c0 .392.313.705.705.705h8.037a.7.7 0 0 0 .705-.705.695.695 0 0 0-.698-.706",
    fill: "#000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m44.695 48.768-.822.69-.175-.21a.71.71 0 0 0-.996-.095.71.71 0 0 0-.095.997l.633.756a.73.73 0 0 0 .48.254h.066a.7.7 0 0 0 .458-.167l1.36-1.149a.705.705 0 0 0-.91-1.076",
    fill: "#E5A033"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.815332 0 0 0 0 0.815332 0 0 0 0 0.815332 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3916_29227"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3916_29227",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlanOnboarding0);
export default __webpack_public_path__ + "static/media/ic_plan_onboarding_0.35a179921fea03243677e48954c0c0ff.svg";
export { ForwardRef as ReactComponent };